import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"

export default class extends Controller {
  static values = { type: String, uuid: String };

  receivedMessage(payload) {
    if (!payload || payload.status === "failed") {
      alert("Document generation failed. Please try again later.");
      window.location.href = '/dashboard';
    } else if (payload.status === "complete") {
      window.location.href = payload.url;
    }
  }

  connect() {
    this.channel = consumer.subscriptions.create(
      { channel: "LoanproReportChannel", type: this.typeValue, uuid: this.uuidValue },
      { received: (data) => this.receivedMessage(data) }
    );
  }

  disconnect() {
    this.channel.unsubscribe();
  }
}
